export const auth_login = "auth/login";
export const auth_logout = "auth/logout";
export const auth_success = "auth/login/success";
export const auth_error = "auth/login/error";
export const is_loading = "isLoading";
export const isMsgFalse = "isMsgFalse";